<app-page-header [title]="'updateNotes.title' | transloco" />

<p class="text-paragraph-md-reg mb-8 mt-4 text-primary-700">
  {{ "updateNotes.subtitle" | transloco }}
</p>

<div>
  @if (isLoading()) {
    <div class="flex h-64 items-center justify-center">
      <i class="pi pi-spin pi-spinner text-4xl text-primary-500"></i>
    </div>
  } @else if (error()) {
    <div class="flex flex-col items-center justify-center py-12 text-center">
      <div class="mb-4 rounded-full bg-error-100 p-4">
        <lucide-icon
          name="megaphone"
          class="text-error-400"
          [size]="16"
        ></lucide-icon>
      </div>
      <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
        {{ "updateNotes.error" | transloco }}
      </h3>
      <p-button
        [label]="'updateNotes.retry' | transloco"
        icon="pi pi-refresh"
        severity="secondary"
        (onClick)="retry()"
      ></p-button>
    </div>
  } @else if (notes().length === 0) {
    <section>
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <div class="mb-4 rounded-full bg-greyscale-100 p-4">
          <lucide-icon
            name="megaphone"
            class="text-greyscale-400"
            [size]="16"
          ></lucide-icon>
        </div>
        <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
          {{ "updateNotes.empty.title" | transloco }}
        </h3>
        <p class="mb-6 max-w-md text-sm text-greyscale-600">
          {{ "updateNotes.empty.description" | transloco }}
        </p>
      </div>
    </section>
  } @else {
    <div class="mb-6">
      <p-selectButton
        [options]="typeOptions()"
        [ngModel]="selectedType()"
        (onChange)="selectedType.set($event.value)"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        data-testid="update-notes-type-filter"
      ></p-selectButton>
    </div>

    @if (filteredNotes().length === 0) {
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <div class="mb-4 rounded-full bg-greyscale-100 p-4">
          <lucide-icon
            name="megaphone"
            class="text-greyscale-400"
            [size]="16"
          ></lucide-icon>
        </div>
        <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
          {{ "updateNotes.emptyFiltered.title" | transloco }}
        </h3>
        <p class="mb-6 max-w-md text-sm text-greyscale-600">
          {{ "updateNotes.emptyFiltered.description" | transloco }}
        </p>
        <p-button
          [label]="'updateNotes.emptyFiltered.clear' | transloco"
          severity="secondary"
          (onClick)="clearFilter()"
        ></p-button>
      </div>
    } @else {
      <div class="flex flex-col gap-4">
        @for (note of filteredNotes(); track note.id) {
          <app-update-note-card [note]="note" />
        }
      </div>
    }
  }
</div>
